import { useEffect, useState } from "react";

import toast from "react-hot-toast";

import { getTenant } from "../../../utils/tenantManager";

import {
  getDueWeightTestsReportApi,
} from "../../../services/operation/reports/reportsApi";

export const useCalibrationAndWeightTestReportViewModel = () => {
  const tenantId = getTenant();

  // ============================================================
  // AUSTRALIA CURRENT DATE
  // ============================================================

  const getAustraliaCurrentDate = () => {
    const now = new Date();

    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "Australia/Sydney",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(now);
  };

  // ============================================================
  // DEFAULT DATE
  // ============================================================

  const today = getAustraliaCurrentDate();

  // ============================================================
  // DATA
  // ============================================================

  const [weightTests, setWeightTests] = useState<any[]>([]);

  // ============================================================
  // LOADING
  // ============================================================

  const [loading, setLoading] = useState(false);

  // ============================================================
  // FILTERS
  // ============================================================

  // Default customer = All
  const [customerName, setCustomerName] = useState("All");

  // Default dates = Australia current date
  const [startDate, setStartDate] = useState(today);

  const [endDate, setEndDate] = useState(today);

  // ============================================================
  // LOAD REPORT
  // ============================================================

  const loadReport = async (
    selectedCustomerName: string = "All",
  ) => {
    try {
      setLoading(true);

      const customerNameValue =
        selectedCustomerName?.trim() || "All";

      const res = await getDueWeightTestsReportApi(
        customerNameValue,
        startDate,
        endDate,
        tenantId!,
      );

      setWeightTests(
        res?.data || [],
      );
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to load weight test report",
      );
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // INITIAL LOAD
  // ============================================================

  useEffect(() => {
    loadReport("All");
  }, []);

  // ============================================================
  // SEARCH REPORT
  // ============================================================

  const searchReport = async (
    selectedCustomerName: string = "All",
  ) => {
    const customerNameValue =
      selectedCustomerName?.trim() || "All";

    setCustomerName(customerNameValue);

    await loadReport(customerNameValue);
  };

  // ============================================================
  // CLEAR FILTERS
  // ============================================================

  const clearFilters = async () => {
    const currentAustraliaDate =
      getAustraliaCurrentDate();

    setCustomerName("All");

    setStartDate(currentAustraliaDate);

    setEndDate(currentAustraliaDate);

    try {
      setLoading(true);

      const res = await getDueWeightTestsReportApi(
        "All",
        currentAustraliaDate,
        currentAustraliaDate,
        tenantId!,
      );

      setWeightTests(
        res?.data || [],
      );
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to clear report",
      );
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // RETURN
  // ============================================================

  return {
    // DATA
    weightTests,

    // LOADING
    loading,

    // FILTERS
    customerName,
    setCustomerName,

    startDate,
    setStartDate,

    endDate,
    setEndDate,

    // ACTIONS
    loadReport,
    searchReport,
    clearFilters,
  };
};